angular.module('picmonic-common').filter('removeHTML', function () {
  return function (text) {
    return text ? String(text).replace(/<[^>]+>/gm, '') : '';
  };
});
